import { render } from "./ZsctWordRightList.vue?vue&type=template&id=1918e090"
import script from "./ZsctWordRightList.vue?vue&type=script&lang=js"
export * from "./ZsctWordRightList.vue?vue&type=script&lang=js"

import "./ZsctWordRightList.vue?vue&type=style&index=0&id=1918e090&lang=scss"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__